export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "";
export const REACT_APP_GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
